// extracted by mini-css-extract-plugin
export var card = "_ou-0";
export var content = "_ou-2";
export var details = "_ou-3";
export var icon = "_ou-1";
export var iconBlue = "_ou-5";
export var iconBrand = "_ou-4";
export var iconGrayBlue = "_ou-6";
export var iconGreen = "_ou-7";
export var iconIndigo = "_ou-8";
export var iconOrange = "_ou-9";
export var iconPurple = "_ou-a";
export var iconRed = "_ou-b";
export var iconWarning = "_ou-c";